/**
 * Light validation for Google Meet URLs.
 * Returns true if the input is empty (valid = no meet) or starts with
 * "https://meet.google.com/". Trims whitespace.
 */
export function isValidGoogleMeetUrl(input: string): boolean {
  const trimmed = input.trim();
  if (trimmed === '') return true;
  return trimmed.startsWith('https://meet.google.com/');
}
